/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OntologyNodeDetail {
    getFixupPrototypeFunction() { return OntologyNodeDetail.fixupPrototype; }

    static newInstance(model: Partial<OntologyNodeDetail>): OntologyNodeDetail {
        let obj = Object.assign(new OntologyNodeDetail(), model);
        OntologyNodeDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OntologyNodeDetail>): OntologyNodeDetail {
        if (!model) return null;
        return OntologyNodeDetail.newInstance(<OntologyNodeDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OntologyNodeDetail) {
        if (!obj) return;

        models.OntologyNodeDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OntologyNodeDetail): boolean {
        Object.setPrototypeOf(obj, OntologyNodeDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Node identifier
     */
    id: string;

    /**
     * Node kind
     */
    type: string;

    /**
     * Summary counts/fields for this node, shape varies by node type
     */
    summary: { [key: string]: any; };

    /**
     * Detailed properties for this node, shape varies by node type
     */
    properties: { [key: string]: any; };

    /**
     * Parent/children linkage for this node
     */
    relationships: { [key: string]: any; };

}
